import { ClientPropertyTypeEnum } from "web_myplann/Infrastructure/Api/Api";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";
import { getPropertyTitle } from "web_myplann/Portfolio/Hooks/usePropertyTitle";
import {
	type BuildingPropertyDetail,
	EditRealEstateForm,
} from "web_myplann/Portfolio/Pages/RealEstateEdit/EditRealEstateForm";
import { PropertyEditLayout } from "web_myplann/Portfolio/PortfolioShared/PropertyEditLayout";

const REAL_ESTATE_EDIT_TYPES = [
	ClientPropertyTypeEnum.Flat,
	ClientPropertyTypeEnum.House,
	ClientPropertyTypeEnum.Cottage,
];

export const EditRealEstatePage = () => {
	const { t } = useResource();

	return (
		<PropertyEditLayout<BuildingPropertyDetail>
			expectedTypes={REAL_ESTATE_EDIT_TYPES}
			title={(property) =>
				t(Resources.Portfolio.EditProperty.title, {
					type: getPropertyTitle(property, t),
				})
			}
		>
			{({ property, propertyId, detailRoute }) => (
				<EditRealEstateForm
					propertyId={propertyId}
					property={property}
					detailRoute={detailRoute}
				/>
			)}
		</PropertyEditLayout>
	);
};
